import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProfileCard from '../components/account/ProfileCard';
import BuoyLightSection from '../components/account/BuoyLightSection';
import { T } from '../components/account/accountStyles';

const GLOBAL_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=Outfit:wght@300;400;500;600;700&display=swap');
`;

export default function AccountSettingsPage() {
  const navigate = useNavigate();
  const { user, grids, token } = useAuth();

  return (
    <div style={{ minHeight: '100vh', background: T.pageBg, fontFamily: T.body, color: '#23261f', paddingTop: 64 }}>
      <style>{GLOBAL_STYLES}</style>

      <div style={{ maxWidth: 1140, margin: '0 auto', padding: '38px 32px 90px' }}>
        <button
          onClick={() => navigate('/ponds')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6, background: 'none',
            border: 'none', cursor: 'pointer', color: T.link, fontSize: 15, fontWeight: 600,
            fontFamily: 'inherit', padding: 0, marginBottom: 18,
          }}
        >
          ← Back to Lake Monitoring
        </button>

        <h1 style={{ fontFamily: T.serif, fontSize: 40, fontWeight: 700, letterSpacing: '-0.4px', color: '#1c2a20', margin: '0 0 8px' }}>
          Account settings
        </h1>
        <p style={{ fontSize: 16, color: T.textMuted, margin: '0 0 32px' }}>
          Manage your account details and the light settings for buoys in grids you can access.
        </p>

        <ProfileCard user={user} />

        <BuoyLightSection grids={grids} token={token} user={user} />
      </div>
    </div>
  );
}
